module.exports = __webpack_public_path__ + "img/news01-M03.e38f745e.jpg";